angular.module 'zc.users'

.controller 'InquiryCtrl', ($scope, $stateParams, $translate, Page, Inquiry, reasons) ->
  $scope.projectId = $stateParams.projectId
  Page.setBodyClass ''

  $translate('users.inquiryController.contact').then (translation) ->
    Page.setTitle translation

  $scope.reasons = reasons
  $scope.isSaving = false

  $scope.submit = (inquiry) ->
    $scope.isSaving = true
    Inquiry.create $scope.projectId, inquiry.message, inquiry.reason
    .finally () ->
      $scope.isSaving = false
      $scope.form.$setPristine()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/inquiry_controller.js.coffee